import { render, staticRenderFns } from "./allchart.vue?vue&type=template&id=06595efa&"
import script from "./allchart.vue?vue&type=script&lang=js&"
export * from "./allchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports